import { hasWindow } from "@litres/utils";
import type {
  IErrorLikeObject,
  IFoundationApiError,
  IRTKQNetworkRequestError,
} from "./originalErrorTypes";
import {
  isErrorFromFoundationApi,
  isErrorLikeObject,
  isNetworkRequestError,
} from "./originalErrorTypes";

const ERROR_POSTFIX_SEPARATOR = "| ";

/**
 * Собирает функции, которые парсят originalError Litres ошибок, чтобы дополнить сообщение об ошибке полезной информацией.
 */
export const errorPostfixMakers = {
  forBackendInteraction: (originalError?: unknown): string => {
    try {
      // Ожидаем, что при выдаче ошибки взаимодействия с бэкендом всегда проставляется originalError. Если нет - пишем об этом в постфиксе, чтоб разработчики отреагировали.
      if (!originalError) {
        return ERROR_POSTFIX_SEPARATOR + "no original error";
      }

      if (isErrorFromFoundationApi(originalError)) {
        return createFoundationApiErrorPostfix(originalError);
      }

      if (isNetworkRequestError(originalError)) {
        return createNetworkRequestErrorPostfix(originalError);
      }

      if (isErrorLikeObject(originalError)) {
        return createErrorLikeObjectErrorPostfix(originalError);
      }

      // Ожидаем, что все возможные типы originalError обработаны в функции. Если нет - пишет об этом в постфиксе, чтоб разработчики добавили обработчик.
      return ERROR_POSTFIX_SEPARATOR + "unexpected original error";
    } catch (error) {
      return createErrorParsingOriginalErrorPostfix();
    }
  },
  forErrorLikeObjects: (originalError?: unknown): string => {
    try {
      if (isErrorLikeObject(originalError)) {
        return createErrorLikeObjectErrorPostfix(originalError);
      }

      if (typeof originalError === "string") {
        return ERROR_POSTFIX_SEPARATOR + originalError;
      }

      return "";
    } catch (error) {
      return createErrorParsingOriginalErrorPostfix();
    }
  },
};

function createFoundationApiErrorPostfix(
  originalError: IFoundationApiError
): string {
  return ERROR_POSTFIX_SEPARATOR + originalError.data.error.type;
}

function createNetworkRequestErrorPostfix(
  originalError: IRTKQNetworkRequestError
): string {
  let result = originalError.data;
  if (hasWindow && !window.navigator.onLine) {
    result += `, offline,`;
  }
  if (originalError.status) {
    result += `, status: ${originalError.status}`;
  }

  return ERROR_POSTFIX_SEPARATOR + result;
}

function createErrorLikeObjectErrorPostfix(
  originalError: IErrorLikeObject
): string {
  return (
    ERROR_POSTFIX_SEPARATOR + `${originalError.name}: ${originalError.message}`
  );
}

function createErrorParsingOriginalErrorPostfix() {
  return ERROR_POSTFIX_SEPARATOR + "error in parsing of originalError";
}
